import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Modal, FormControl } from "react-bootstrap"
import { get } from "lodash"

import Button from "../../components/Button"
import { editItem } from "../../ducks/routes"
import { updateReservation } from "../../ducks/reservations";

/* Edita el campo de `time` (horario) desde una reserva
 * hace el cambio tanto en la reserva como en el item de la ruta!
 * 
 * A pesar de que recibe los datos del padre, despacha directamente las 
 * acciones vía mapDispatchToProps. Esto es muy irregular y puede ser 
 * confuso, lo sé. 
 */

class EditTimeModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      value: this.getSavedTime(props)
    }
  }
  
  getSavedTime(props = null) {
    return get(props || this.props, "agendaItem.time", "")
  }
  
  saveAndClose() {
    this.props.save(this.state.value)
    this.props.onClose()
  }
  
  render() {
    return (
      <Modal show onHide={this.props.onClose}>
        <Modal.Header>
          <Modal.Title>
            Editar horario
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormControl 
            style={{ width: "50%", margin: "auto" }}
            value={this.state.value} 
            onChange={evt => this.setState({ value: evt.target.value })} 
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="success"
            glyph="save"
            onClick={() => this.saveAndClose()}
            disabled={this.getSavedTime() == this.state.value}
          >
            Guardar
          </Button>
          <Button 
            onClick={this.props.onClose}
            label={this.getSavedTime() == this.state.value ? "Cancelar" : "Cerrar"}
          />
        </Modal.Footer>
      </Modal>
    )
  }
}

EditTimeModal.propTypes = {
  // from connect
  save: PropTypes.func.isRequired,
  
  // from daddy
  agendaItem: PropTypes.object.isRequired,
  reservationId: PropTypes.string.isRequired,
  itemKey: PropTypes.string.isRequired,
  route: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
}

function mapStateToProps(_state, ownProps) {
  const { route, itemKey } = ownProps
  return {
    agendaItem: route.agenda.find(item => item.key == itemKey)
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    save: time => {
      const routeId = ownProps.route._id
      const itarget = ownProps.route.agenda.findIndex(item => item.key == ownProps.itemKey)
      const action = editItem(routeId, itarget, { time })
      dispatch(action)
      
      const resId = ownProps.reservationId
      dispatch(updateReservation(resId, { time }))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditTimeModal)